export const TYPE_TACHE = {
	RECOLTE: 'RECOLTE',
	// Réfère à un suffixe pour l'ensemble des tâches de type tri
	TRI : 'TRI',
	// Réfère à un préfixe pour l'ensemble des tâches de type fertilisation
	FERTI: 'FERTI'
}

export const TYPE_MO_TACHE = {
	GENERIQUE: 'generique',
	VARIANTE : 'variante',
	INDEPENDANTE: 'independante'
}

export const OUI_NON = {
	OUI: { value: 'OUI', label: 'Oui' },
	NON: { value: 'NON', label: 'Non' }
}

export const ACTION_TYPE = {
	TERMINEE: 'TERMINEE',
	DEMARRAGE_IMPOSSIBLE: 'DEMARRAGE_IMPOSSIBLE',
	NONE: 'NONE'
}